import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';

import { Button } from '@lwt-helix/buttons';

import UsersTable from './UsersTable';
import { backgroundStyles } from './styles/Table.css';
import { mutedHeaderStyles } from '../../../common/styles/Header.css';
import { getUsersForTable } from '../SecurityGroupFunctions';
import { setStateData } from '../../../common/StateHelper';

const UsersTableContainer = props => {
    const { securityGroupUsers } = props;

    const securityGroup = useSelector(state => state.securityGroup.securityGroup);
    const authenticationUsers = useSelector(state => state.authenticationReducer.users);

    const [state, setState] = useState({
        users: [],
        authenticationUsers: [],
        securityGroup: {},
        usersToDisplay: []
    });

    const formatUsersForTable = users => {
        let rows = [];
        if (users && users.length) {
            users.forEach((user) => {
                let name = user.firstName + ' ' + user.lastName;
                let row = { name, id: user.id };
                rows.push(row);
            });
        }
        return rows;
    };

    useEffect(() => {
        authenticationUsers && securityGroupUsers && setStateData(
            'users',
            getUsersForTable(securityGroupUsers, authenticationUsers),
            setState
        );
    }, []);

    useEffect(() => {
        setStateData('authenticationUsers', authenticationUsers, setState);
    }, [authenticationUsers]);

    useEffect(() => {
        let usersToDisplay = formatUsersForTable(state.users);
        setStateData('usersToDisplay', usersToDisplay, setState);
    }, [state.users]);

    useEffect(() => {
        setState(prevState => {
            return {
                ...prevState,
                securityGroup,
                authenticationUsers,
                users: getUsersForTable(securityGroup.users, authenticationUsers)
            };
        });
    }, [securityGroup, authenticationUsers]);

    return (
        <div className="mt-3 p-3" style={backgroundStyles}>
            <div className={'row mb-2'}>
                <div className={'col-6'}>
                    <h4 style={mutedHeaderStyles}>Users</h4>
                    <small className={'pl-2'}
                           style={{ fontSize: '12px' }}>{state.users ? state.users.length : 0} Results
                    </small>
                </div>
                <div className={'col-3 offset-3'}>
                    <Button
                        dataLwtId="add-users"
                        className="float-right"
                        style={{ borderRadius: '3px' }}
                        onClick={() => props.toggleSecurityModal()}
                    >
                        Add Users
                    </Button>
                </div>
            </div>
            <UsersTable users={state.usersToDisplay} />
        </div>
    );
};

UsersTableContainer.propTypes = {
    securityGroupUsers: PropTypes.array,
    toggleSecurityModal: PropTypes.func
};

export default UsersTableContainer;